import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { PaymentMethod } from './payment-method.entity';

export class CreatePaymentMethodDto extends Omit(PaymentMethod, BaseEntityFieldsArray) {}
